import { createContext } from 'react'

type ContextState = {
  readOnly: boolean
  disabled: boolean
}

export const CustomContext = createContext<ContextState>({
  readOnly: false,
  disabled: false
})
